import store from '@/store'
import { Message } from 'element-ui'
import {getToken} from '@/utils/auth.js'

export function getDownloadAddress(path, name) {
    return `/api/file/common/download?fileUri=${path}&rename=tipdm-race-web`;
}

export function judgePermissions(value) {
    return new Promise((resolve, reject) => {
        store.dispatch("getPermissionsList").then((res) => {
            const permissions = res;
            if (value && value instanceof Array && value.length > 0) {
                const permissionFlag = value[0];
                const hasPermissions = permissions.includes(permissionFlag)
                if (hasPermissions) {
                    resolve(true)
                } else {
                    Message({
                        message: '您没有权限访问此页面，缺失权限码：' + permissionFlag,
                        type: 'error',
                        duration: 3000
                    })
                }
            } else {
                reject(true)
            }
        })
    });
}

export function getRandomNum(len) {
    let rand = "";
    for (let i = 0; i < len; i++) {
        rand += Math.floor(Math.random() * 10)
    }
    return rand;
}

// 日期格式化
export function parseTime(time, pattern) {
    if (arguments.length === 0 || !time) {
        return null
    }
    const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
        } else if (typeof time === 'string') {
            time = time.replace(new RegExp(/-/gm), '/');
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
}

/**
 * 获取分钟数
 * @param duration
 * @param durationUnit
 * @returns {*|number}
 */
export function getMinute(duration, durationUnit) {
    let result = duration
    switch (durationUnit) {
        case 'minute':
            result = duration
            break;
        case 'hour':
            result = duration * 60
            break;
        case 'day':
            result = duration * 60 * 24
            break;
        default:
    }
    return result
}

/**
 * 带进度监听的文件下载函数
 * @param {string} url - 下载地址
 * @param {string} method - 请求方法
 * @param {string} fileName - 文件名
 * @param {object} params - 请求参数
 * @param {function} onProgress - 进度回调函数 (loaded: number, total: number, percent: number)
 */
export function downloadBolbFile(url, method, fileName, params, onProgress = null) {
    const xhr = new XMLHttpRequest()
    if (method === "get" && params || method === "GET" && params) {
        const dataParam = new URLSearchParams(params)
        url = `${url}?${dataParam}`
    }
    xhr.open(method, url)
    xhr.setRequestHeader('Authorization', "Bearer " + getToken()) // 设置 Header
    xhr.responseType = 'blob' // 指定响应类型

    // 添加进度监听
    if (onProgress && typeof onProgress === 'function') {
        xhr.addEventListener('progress', (event) => {
            if (event.lengthComputable) {
                const percentComplete = (event.loaded / event.total) * 100
                onProgress(event.loaded, event.total, percentComplete, 'success')
            } else {
                // 如果无法获取总大小，则只传递已加载的字节数
                onProgress(event.loaded, null, null, 'success')
            }
        })
    }

    xhr.onload = () => {
        if (xhr.status === 200) {
            const blob = xhr.response
            const downloadUrl = window.URL.createObjectURL(blob)
            const tempLink = document.createElement('a')
            tempLink.href = downloadUrl
            tempLink.download = fileName
            tempLink.style.display = 'none'
            document.body.appendChild(tempLink)
            tempLink.click()
            window.URL.revokeObjectURL(downloadUrl)
            document.body.removeChild(tempLink)

            // 下载完成后调用进度回调（100%）
            if (onProgress) {
                const total = xhr.getResponseHeader('Content-Length')
                if (total) {
                    onProgress(parseInt(total), parseInt(total), 100, 'success')
                } else {
                    onProgress(null, null, 100, 'success')
                }
            }
        }
        if (xhr.status === 500) {
            const blob = xhr.response
            blobToString(blob).then(text => {
                let resp = JSON.parse(text)
                Message({
                    message: resp.message,
                    type: 'error',
                    duration: 5 * 1000,
                })
            }).catch(error => {
                Message({
                    message: '请求失败',
                    type: 'error',
                    duration: 5 * 1000,
                })
            })
            onProgress(null, null, null, 'error')
        }
    }

    xhr.onerror = () => {
        Message({
            message: '网络请求失败',
            type: 'error',
            duration: 5 * 1000,
        })
        onProgress(null, null, null, 'error')
    }

    // 发送请求
    xhr.send(method === 'get' || method === 'GET' ? null : params)
}

/**
 * 将字符串型blob转为字符串
 * @param blob
 * @returns {Promise<any>}
 */
function blobToString(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
            resolve(reader.result)
        }
        reader.onerror = () => {
            reject(reader.error)
        }
        reader.readAsText(blob) // 读取为文本
    })
}

